jQuery(function($){
  $(document).ready(function() {

    $('.product__info-wrapper variant-radios .product-form__input input').each(function(){
        $(this).click(function(){
          $('product__info-wrapper variant-radios .product-form__input input').prop('checked', false);
          $(this).attr('checked');


          $('.product__info-wrapper variant-radios .product-form__input label').removeClass('active_variation');
          $(this).next('label').addClass('active_variation');
          
          setTimeout(function() {  
            $('.product-form__buttons .product-form__submit').removeAttr('disabled');
          }, 1000);
          
        })
    });

    $('.cart_item_vari:contains("Default Title")').addClass('cart_single_product');

     
    $('.menu-drawer__menu li').each(function(){
        var href=$(this).find('a').prop('href');
          if (href.indexOf('embellish') > -1) {
            $(this).find('.nav-sub-info').text('Embellish');
        }
        if (href.indexOf('bundles') > -1) {
            
          $(this).find('.nav-sub-info').text('Gift Bundles');
        }
        if (href.indexOf('home-fragrance') > -1) {
          $(this).find('.nav-sub-info').text('PILLAR CANDLES');
        }


    });



  var priceValues = $('.variation_price_listing .variation_price').map(function() {
    return $(this).text();
  }).get();

  var priceQuantity = $('.variation_selection_feild .variation_price_listing .variation_quantity').map(function() {
    return $(this).text();
  }).get();

  var variationId = $('.variation_selection_feild .variation_price_listing .variation_id').map(function() {
    return $(this).text();
  }).get();


  $('.variation_selection_feild label').each(function(index) {
    $(this).attr('data-price', priceValues[index]);
    $(this).attr('data-quantity', priceQuantity[index]);
    $(this).attr('data-id', variationId[index]);
    
    
    
  });

    $('.variation_selection_feild label').each(function(){

      $(this).click(function(){

          var priceValue = $(this).data('price');
          var VariQuantity =  $(this).data('quantity');
          var VariId =  $(this).data('id');
        
        

            $('.product-form form input[name="id"]').val(VariId);
            setTimeout(function() {
              $('.product-form__buttons span').text(function(index, currentText) {

                    if (VariQuantity == 0 ) {
                     
                      $('.product-form__buttons .product-form__submit').addClass('disable_btn');
                      return 'Sold Out' + ' - ' + priceValue + 'AUD';
                      
                    } else {
                      $('.product-form__buttons .product-form__submit').removeClass('disable_btn');
                      
                       return 'Add To Your Cart' + ' - ' + priceValue + 'AUD';
                       
               
                    }
                     
                
              });
            }, 800);


        var variationValue = $(this).data('title');
          $('.variation_images').each(function() {
              if ($(this).data('title') === variationValue) {
             var sliderIndex = $(this).parents('.slick-slide ').data('slick-index');

                 $('.slick-slider').slick('slickGoTo', sliderIndex);
                  // return false;
                
              }
            //  $('.vertical-product-gallery .slick-slide').each(function(index) {
            //   if ($(this).find('.variation_images').data('title') === variationValue) {
            //     $(this).parents('.slick-slide ').slick('slickGoTo', index);
            //     return false;
            //   }
            // });

            
          });

         
    });
  });
    
  }); // end of ready func.
});


